/**
 * @graphql agg
 */

import { graphql } from 'react-relay';

import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

import { type SnippetOwner } from '../snippetTypes.ts';
import type {
	blockServiceUserInfoQuery$data,
	blockServiceUserInfoQuery$variables,
} from './__generated__/blockServiceUserInfoQuery.graphql.ts';

export const fetchUserInfo = async (accountId: string): Promise<SnippetOwner | undefined> => {
	try {
		const { data, errors } = await queryInterop<
			blockServiceUserInfoQuery$data,
			blockServiceUserInfoQuery$variables
		>({
			query: graphql`
				query blockServiceUserInfoQuery($accountId: ID!) {
					user(accountId: $accountId) {
						accountId
						displayName: name
						avatarUrl: picture
					}
				}
			`,
			variables: {
				accountId: accountId,
			},
		});

		errors?.forEach((error) => {
			logFetchError(error);
			markErrorAsHandled(error);
		});

		// @ts-ignore
		return data.user ?? undefined;
	} catch (error) {
		logFetchError(error);
		markErrorAsHandled(error);
		return undefined;
	}
};

const logFetchError = (maybeError: Error | undefined) => {
	const error = maybeError instanceof Error ? maybeError : new Error(String(maybeError));
	const errorToLog = new Error(
		`Error when fetching Snippet owner user details: ${error?.message || JSON.stringify(error)}`,
	);
	getMonitoringClient().submitError(errorToLog, {
		attribution: Attribution.INTEGRATIONS,
	});
};
